// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__6bopy","header":"MessagesList_header__1pzyO","chat":"MessagesList_chat__1AaT8"};